import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';


const BrandingConfigurationStep = ({ formData, onChange }) => {
  const previewUrl = formData?.slug 
    ? `${window?.location?.origin}/p/${formData?.slug}` 
    : `${window?.location?.origin}/p/votre-slug`;

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-6">
        <Icon name="Palette" size={24} className="text-blue-600" />
        <div>
          <h2 className="text-xl font-bold text-gray-900">Configuration du Branding</h2>
          <p className="text-sm text-gray-600">Personnalisation du formulaire public</p>
        </div>
      </div>

      {/* URL Slug */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          URL Slug <span className="text-red-500">*</span>
        </label>
        <Input
          value={formData?.slug}
          onChange={(e) => onChange?.('slug', e?.target?.value?.toLowerCase())}
          placeholder="dr-dupont"
          required
        />
        <p className="mt-1 text-xs text-gray-500">
          URL publique: <code className="bg-gray-100 px-2 py-1 rounded">{previewUrl}</code>
        </p>
      </div>

      {/* Color Pickers */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Couleur Principale
          </label>
          <div className="flex items-center gap-3">
            <input
              type="color"
              value={formData?.primaryColor}
              onChange={(e) => onChange?.('primaryColor', e?.target?.value)}
              className="h-10 w-20 rounded border border-gray-300 cursor-pointer"
            />
            <Input
              value={formData?.primaryColor}
              onChange={(e) => onChange?.('primaryColor', e?.target?.value)}
              placeholder="#2563eb"
            />
          </div>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Couleur Secondaire
          </label>
          <div className="flex items-center gap-3">
            <input
              type="color"
              value={formData?.secondaryColor}
              onChange={(e) => onChange?.('secondaryColor', e?.target?.value)}
              className="h-10 w-20 rounded border border-gray-300 cursor-pointer"
            />
            <Input
              value={formData?.secondaryColor}
              onChange={(e) => onChange?.('secondaryColor', e?.target?.value)}
              placeholder="#1e40af"
            />
          </div>
        </div>
      </div>

      {/* Preview */}
      <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
        <h3 className="text-sm font-semibold text-gray-700 mb-4 flex items-center gap-2">
          <Icon name="Eye" size={18} />
          Aperçu du Branding
        </h3>
        <div 
          className="rounded-lg p-6 text-white"
          style={{ 
            background: `linear-gradient(135deg, ${formData?.primaryColor} 0%, ${formData?.secondaryColor} 100%)` 
          }}
        >
          <h4 className="text-2xl font-bold mb-2">{formData?.practiceName || 'Nom du Cabinet'}</h4>
          <p className="text-white/90">
            {formData?.practitionerTitle} {formData?.practitionerName || 'Nom du Praticien'}
          </p>
          <p className="text-sm text-white/80 mt-4">
            Formulaire de Référal Endodontique
          </p>
        </div>
      </div>

      {/* Info Box */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} className="text-blue-600 flex-shrink-0 mt-0.5" />
          <div className="text-sm text-blue-800">
            <p className="font-medium mb-1">Personnalisation du formulaire</p>
            <p>
              Ces couleurs seront appliquées au formulaire de référal public accessible via l'URL personnalisée. Les dentistes référents verront votre branding lors de l'envoi de cas.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandingConfigurationStep;